import React, { useContext, useState } from 'react';
import './faqSection.css';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Button, Typography } from '@mui/material';
import { MyContext } from '../../context';

function Faqsection() {
  const { pageData } = useContext(MyContext);

  const [expanded, setExpanded] = useState(false);

  const handleChange = (isExpanded) => {
    setExpanded(isExpanded);
  };
  return (
    <section className="faqSection">
      <div className="container">
        <div className="faqContainer">
          <div className="commonHeading">
            <h2 style={{ marginBottom: '10px' }}>
              {pageData?.faqPage?.header}
            </h2>
            <p className="p-padding-top">{pageData?.faqPage?.subtitle}</p>
          </div>
          <div className="faq-container-wrap">
            <div className="faq-container-wrap-left">
              {pageData?.faqPage?.faqData?.map((item, index) => {
                return (
                  <div key={index} style={{ margin: '10px' }}>
                    {index < pageData?.faqPage?.faqData.length / 2 && (
                      <Accordion
                        expanded={expanded === item?.question}
                        onChange={() => handleChange(item?.question)}
                        sx={{
                          boxShadow:
                            '0px 10px 20px 0px rgba(164, 172, 179, 0.4) !important',
                        }}
                      >
                        <AccordionSummary
                          expandIcon={
                            expanded === item?.question ? (
                              <RemoveIcon />
                            ) : (
                              <AddIcon />
                            )
                          }
                        >
                          <p
                            className="p-padding-top"
                            style={{
                              fontFamily: 'matter',
                              color: 'black',
                            }}
                          >
                            {item?.question}
                          </p>
                        </AccordionSummary>
                        <AccordionDetails>
                          <p>{item?.answer}</p>
                        </AccordionDetails>
                      </Accordion>
                    )}
                  </div>
                );
              })}
            </div>
            <div className="faq-container-wrap-left">
              {pageData?.faqPage?.faqData?.map((item, index) => {
                return (
                  <div key={index} style={{ margin: '10px' }}>
                    {index >= pageData?.faqPage?.faqData.length / 2 && (
                      <Accordion
                        expanded={expanded === item?.question}
                        onChange={() => handleChange(item?.question)}
                        sx={{
                          boxShadow:
                            '0px 10px 20px 0px rgba(164, 172, 179, 0.4) !important',
                        }}
                      >
                        <AccordionSummary
                          expandIcon={
                            expanded === item?.question ? (
                              <RemoveIcon />
                            ) : (
                              <AddIcon />
                            )
                          }
                        >
                          <p
                            className="p-padding-top"
                            style={{
                              fontFamily: 'matter',
                              color: 'black',
                            }}
                          >
                            {item?.question}
                          </p>
                        </AccordionSummary>
                        <AccordionDetails>
                          <p>{item?.answer}</p>
                        </AccordionDetails>
                      </Accordion>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
          {/* <div className="faq-cards-container">
            {faqData?.map((item) => {
              return (
                <div className="faq-card">
                  <h6>{item?.question}</h6>
                  <p>{item?.answer}</p>
                </div>
              );
            })}
          </div> */}
        </div>
      </div>
    </section>
  );
}

export default Faqsection;
